// 页面常量文件
export const NUM2 = 2;
export const NUM3 = 3;
export const NUM4 = 4;
export const NUM5 = 5;
export const NUM6 = 6;
export const NUM7 = 7;
export const NUM8 = 8;
export const NUM9 = 9;
export const NUM10 = 10;



// WEBPACK FOOTER //
// ./src/constant.js